import Vue from "vue";
import VueRouter from "vue-router";
import HomeIndia from "../views/HomeIndia.vue";
import HomeNew from "../views/HomeNew.vue";
import CreateAccount from "../views/CreateAccount";
import CreateAccountIndia from "../views/CreateAccountIndia";
import applicationList from "../views/applicationList";
import wizard from "../views/wizard";
import indicatorType from "../views/indicatorType";
import manageRequest from "../views/manageRequest"
import indicatorGroup from "../views/indicatorGroup";
import indicatorAdd from "../views/indicatorAdd";
import alertAdd from "../views/alertAdd";
import outlierAdd from "../views/outlierAdd";
// import advancedOptions from "../views/advancedOptions";
import profile from "../views/profile";
import changePassword from "../views/changePassword";
import organisationUnit from "../views/organisationUnit";
import selectApp from "../views/selectApp";
// import selectPlan from "../views/selectPlan";
import generateExamId from "../views/generateExamId";
import questionsList from "../views/questionsList";
import scoreBoard from "../views/scoreBoard";
import reviewExam from "../views/reviewExam";
import certificate from "../views/certificate";
import facilitator from "../views/facilitator";
import facilitatorPage from "../views/facilitatorPage";
import facilitatorMenu from "../views/facilitatorMenu";
import resourcesSession from "../views/resourcesSession";
import facilitatorCourse from "../views/facilitatorCourse";
import agendaDoc from "../views/agendaDoc";
// import uploadAgenda from "../views/uploadAgenda";
import trainingAgenda from "../views/trainingAgenda";
// import userRoles from "../views/userRoles";
import certificateStatus from "../views/certificateStatus";
import trainingFaq from "../views/trainingFaq";
import wizardStep1 from "../views/wizardStep1";
import wizardContentManagement from "../views/wizardContentManagement";
import wizardStep2 from "../views/wizardStep2";
import wizardDataUpload from "../views/wizardDataUpload";
// import selectAdmin from "../views/selectAdmin";
import training_wizard from "../views/training_wizard";
import organisationGroup from "../views/organisationGroup";
import noPageFound from "../views/noPageFound";
import deleteMetaData from "../views/deleteMetaData";


Vue.use(VueRouter);

const routes = [
    {
        path: "/HomeIndia",
        name: "HomeIndia",
        component: HomeIndia,
        meta: { title: 'Sign in' }
    },
    {
        path: "/",
        name: "homeNew",
        // component: HomeNew, //Vizibuzz
        // component: HomeIndia, //India
        component: () => {
          return settings.countryName.toLowerCase() === 'india' ? import ("../views/HomeIndia.vue") : import ("../views/HomeNew.vue")
        }, //India
        meta: { title: 'Sign in' }
    },
    {
        path: "/create-account-India",
        name: "createaccountIndia",
        component: CreateAccountIndia,
        meta: { title: 'Create Account' }
    },
    {
        path: "/create-account",
        name: "createaccount",
        component: CreateAccount,
        meta: { title: 'Create Account' }
    },
    {
        path: "/activate",
        name: "activate",
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
            import ("../views/Activation.vue"),
        meta: { title: 'Activate Account' }
    },
    {
        path: "/activate-india",
        name: "activateIndia",
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
            import ("../views/ActivationIndia.vue"),
        meta: { title: 'Activate Account' }
    },
    {
        path: "/applicationList",
        name: "applicationList",
        component: applicationList,
        meta: { title: 'Application List' }
    },
    {
        path: "/manageRequest",
        name: "manageRequest",
        component: manageRequest,
        meta: { title: 'Manage Request' }
    },
    {
        path: "/wizard/:id",
        name: "wizard",
        component: wizard,
        meta: { title: 'Application Configuration' }
    },
    {
        path: "/createApplication/:id",
        name: "createApplication",
        component: wizard,
        meta: { title: 'Application Configuration' }
    },
    {
        path: "/wizardStep1",
        name: "wizardStep1",
        component: wizardStep1,
        meta: { title: 'Application Configuration' }
    },
    {
        path: "/wizardStep2",
        name: "wizardStep2",
        component: wizardStep2,
        meta: { title: 'Application Configuration' }
    },

    {
        path: "/wizardContentManagement",
        name: "wizardContentManagement",
        component: wizardContentManagement,
        meta: { title: 'Application Configuration' }
    },
    {
        path: "/wizardDataUpload",
        name: "wizardDataUpload",
        component: wizardDataUpload,
        meta: { title: 'Application Configuration' }
    },
    {
        path: "/indicatorType",
        name: "indicatorType",
        component: indicatorType,
        meta: { title: 'Indicator Type' }
    },
    {
        path: "/indicatorGroup",
        name: "indicatorGroup",
        component: indicatorGroup,
        meta: { title: 'Indicator Group' }
    },
    {
        path: "/indicatorAdd",
        name: "indicatorAdd",
        component: indicatorAdd,
        meta: { title: 'Add Indicator' }
    },
    {
        path: "/alertAdd",
        name: "alertAdd",
        component: alertAdd,
        meta: { title: 'Add Alert' }
    },
    {
        path: "/outlierAdd",
        name: "outlierAdd",
        component: outlierAdd,
        meta: { title: 'Add Outlier' }
    },
    {
        path: "/training_wizard",
        name: "training_wizard",
        component: training_wizard,
        meta: { title: 'Training Wizard' }
    },
    {
        path: "/profile",
        name: "profile",
        component: profile,
        meta: { title: 'Application Configuration' }
    },
    {
        path: "/changePassword",
        name: "changePassword",
        component: changePassword,
        meta: { title: 'Application Configuration' }
    },
    {
        path: "/organisationUnit",
        name: "organisationUnit",
        component: organisationUnit,
        meta: { title: 'Application Configuration' }
    },
    {
        path: "/select-app",
        name: "select-app",
        component: selectApp,
        meta: { title: 'Application Configuration' }
    },
    // {
    //     path: "/select-plan",
    //     name: "select-plan",
    //     component: selectPlan,
    //     meta: { title: 'Application Configuration' }
    // },
    // {
    //     path: "/select-admin",
    //     name: "select-admin",
    //     component: selectAdmin,
    //     meta: { title: 'Application Configuration' }
    // },

    {
        path: "/exam-id",
        name: "exam-id",
        component: generateExamId,
        meta: { title: 'Application Configuration' }
    },
    {
        path: "/question-list",
        name: "question-list",
        component: questionsList,
        meta: { title: 'Application Configuration' }
    },
    {
        path: "/score-board",
        name: "score-board",
        component: scoreBoard,
        meta: { title: 'Application Configuration' }
    },
    {
        path: "/review-exam",
        name: "review-exam",
        component: reviewExam,
        meta: { title: 'Application Configuration' }
    },
    {
        path: "/certificate",
        name: "certificate",
        component: certificate,
        meta: { title: 'Application Configuration' }
    },
    {
        path: "/facilitator",
        name: "facilitator",
        component: facilitator,
        meta: { title: 'Application Configuration' }
    },
    {
        path: "/facilitator-page",
        name: "facilitator-page",
        component: facilitatorPage,
        meta: { title: 'Application Configuration' }
    },
    {
        path: "/facilitator-menu",
        name: "facilitator-menu",
        component: facilitatorMenu,
        meta: { title: 'Application Configuration' }
    },
    {
        path: "/resources-session",
        name: "resources-session",
        component: resourcesSession,
        meta: { title: 'Application Configuration' }
    },
    {
        path: "/facilitator-course",
        name: "facilitator-course",
        component: facilitatorCourse,
        meta: { title: 'Application Configuration' }
    },
    {
        path: "/agenda-doc",
        name: "agenda-doc",
        component: agendaDoc,
        meta: { title: 'Application Configuration' }
    },
    // {
    //     path: "/upload-agenda",
    //     name: "upload-agenda",
    //     component: uploadAgenda,
    //     meta: { title: 'Application Configuration' }
    // },
    {
        path: "/training-agenda",
        name: "training-agenda",
        component: trainingAgenda,
        meta: { title: 'Application Configuration' }
    },
    // {
    //     path: "/user-roles",
    //     name: "user-roles",
    //     component: userRoles,
    //     meta: { title: 'Application Configuration' }
    // },
    {
        path: "/certificate-status",
        name: "certificate-status",
        component: certificateStatus,
        meta: { title: 'Application Configuration' }
    },
    {
        path: "/training-faq",
        name: "training-faq",
        component: trainingFaq,
        meta: { title: 'Application Configuration' }
    },
    {
        path: "/organisationGroup",
        name: "organisationGroup",
        component: organisationGroup,
        meta: { title: 'Organisation Group' }
    },
    {
        path: "/deleteMetaData",
        name: "deleteMetaData",
        component: deleteMetaData,
        meta: { title: 'Delete Metadata' }
    },
    {
        path: "*",
        component: noPageFound,
    },
];

const router = new VueRouter({
    //mode: 'history',
    routes
});

export default router;
